import { INITIAL_FORMS_PERIOD_QUERY } from "~/store/helpers/defaults";

export default function reducer(state = {
    query: "",
    period_query: INITIAL_FORMS_PERIOD_QUERY,
    tab: "forms",
    forms: [],
    schedules: [],
    position: 0,
    pagination: 1,
    filterOptions: {
        forms: [],
        schedules: [],
        categories: [],
    },
}, action) {

    switch (action.type) {

        case "updateFormsFilterQuery": {
            return Object.assign({}, state, {
                query: action.payload
            });
        }

        case "updateFormsPeriodQuery": {
            return Object.assign({}, state, {
                period_query: action.payload
            });
        }

        case "updateFormsTab": {
            return Object.assign({}, state, {
                tab: action.payload
            });
        }

        case "updatePagePosition": {
            return Object.assign({}, state, {
                position: action.payload
            });
        }

        case "updatePagination" : {
            return Object.assign({}, state, {
                pagination: action.payload
            });
        }

        case "updateFiltersForms": {
            return Object.assign({}, state, {
                forms: action.payload
            });
        }

        case "updateFiltersSchedules": {
            return Object.assign({}, state, {
                schedules: action.payload
            });
        }

        case "updateFilterOptions": {
            return Object.assign({}, state, {
                filterOptions: {
                    ...state.filterOptions,
                    ...action.payload,
                }
            });
        }

        default: {
            return state;
        }

    }

}